import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import * as API from "../Endpoints/Endpoints";

const CubeMaster = () => {
  const [file, setFile] = useState(null);
  const [cubeData, setCubeData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const fetchData = () => {
    axios.get(API.GET_CUBEDATA_API)
      .then((res) => {
        setCubeData(res.data);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleUpload = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return alert("No file selected.");

    if (!selectedFile.name.endsWith('.xlsx') && !selectedFile.name.endsWith('.xls')) {
      alert("Please upload an Excel file (.xlsx or .xls)");
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    axios.post(API.UPLOAD_CUBEDATA_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        console.log(`Upload progress: ${percent}%`);
      },
    })
      .then(() => {
        alert("File uploaded and data added successfully.");
        fetchData();
      })
      .catch((err) => {
        console.error("Upload error:", err.response?.data || err.message);
        alert("Error uploading file: " + (err.response?.data?.message || err.message));
      });
  };

  // Utility to highlight search term in text
  const highlightText = (text) => {
    if (!searchTerm) return text;
    const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
    return parts.map((part, i) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span key={i} className="bg-orange-300">{part}</span>
      ) : (
        part
      )
    );
  };

  // Filtered data if search term exists
  const filteredData = cubeData.filter((item) =>
    Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const DeleteCube = (cubeid) => {
    console.log("Deleting cubeid: ", cubeid);
    if (window.confirm("Are you sure you want to delete this Cube data?")) {
        axios({
            url: API.DELETE_CUBE_API(cubeid),
            method: 'DELETE',
        }).then((res) => {
            alert("Deleted cube successfully");
            fetchData();
        }).catch((err) => {
            alert("Error: " + err);
        });
    }
  };
  
  
      const ViewCube = (cubeid) => {
          navigate(`/viewcube/${cubeid}`);
      };
  
      const UpdateCube = (cubeid) => {
          navigate(`/updatecube/${cubeid}`);
      };

  return (
    <div className="p-6">

      <div className="flex flex-col md:flex-row justify-between items-center mb-6">
        <h2 className="text-2xl font-bold mb-4 md:mb-0">Cube Game Data Master</h2>
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="p-2 border rounded md:w-1/3"
        />
      </div>

     <div className="mt-2"> <button className="bg-gray-200 text-black font-semibold py-2 px-5 rounded-full" onClick={() => navigate("/addcube")}>
                    Add Cube Data
                </button> </div>

      <div className="mb-6 mt-2">
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleUpload}
          className="p-2 border rounded w-full md:w-1/2"
        />
      </div>

      <div className="overflow-x-auto">

       

        <table className="table-auto border-collapse w-full border border-gray-300 bg-gray-200">
          <thead>
            <tr className="bg-[#e64a32] text-white">
              <th className="border p-2">Sr No</th>
              <th className="border p-2">Religion</th>
              <th className="border p-2">Theme</th>
              <th className="border p-2">Type</th>
              <th className="border p-2">Passion Dimension</th>
              <th className="border p-2">Question</th>
              <th className="border p-2">Related SDG</th>
              <th className="border p-2">Age Group</th>
              <th className="border p-2">Known Religious Lead</th>
              <th className="border p-2">Brief Description of Lead</th>
              <th className="border p-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((cube, index) => (
                <tr key={cube.cubeid} className="hover:bg-gray-50">
                  <td className="border p-2">{index + 1}</td>
                  <td className="border p-2">{highlightText(cube.religion)}</td>
                  <td className="border p-2">{highlightText(cube.theme)}</td>
                  <td className="border p-2">{highlightText(cube.type)}</td>
                  <td className="border p-2">{highlightText(cube.passiondimension)}</td>
                  <td className="border p-2">{highlightText(cube.question)}</td>
                  <td className="border p-2">{highlightText(cube.relatedSDG)}</td>
                  <td className="border p-2">{highlightText(cube.agegroup)}</td>
                  <td className="border p-2">{highlightText(cube.knownreligiouslead)}</td>
                  <td className="border p-2">{highlightText(cube.briefdescriptionoflead)}</td>
                  <td className="py-4 px-6 text-sm font-medium text-center text-gray-900 dark:text-white">
                       <button onClick={() => ViewCube(cube.cubeid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1">View</button>
                       <button onClick={() => UpdateCube(cube.cubeid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Edit</button>
                       <button onClick={() => DeleteCube(cube.cubeid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Delete</button>
                 </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center p-4">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CubeMaster;
